import { useState, useCallback, useRef } from 'react';

export const useAccordionItem = () => {
  const [measuredHeight, setMeasuredHeight] = useState(0);
  const observerRef = useRef(null);

  const handleRef = useCallback((node) => {
    // Clean up previous observer
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (node) {
      const measure = () => setMeasuredHeight(node.scrollHeight);
      measure();
      if (typeof ResizeObserver !== 'undefined') {
        const obs = new ResizeObserver(measure);
        obs.observe(node);
        observerRef.current = obs;
      }
    }
  }, []);

  return {
    measuredHeight,
    handleRef,
  };
};
